import { AriaFormatter } from '../../types';

export const defaultCarouselAriaLabelFormatter: AriaFormatter = (
  currentSlideIndex,
  slideCount
) => `Слайд ${currentSlideIndex + 1} из ${slideCount}`;

export const defaultSlideAriaLabelFormatter: AriaFormatter = (slideIndex) =>
  `Слайд ${slideIndex + 1}`;
